"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INLINE_IAMGE_MIME_TYPES = exports.HIGHLIGHT_LIGHT_COLOR = exports.HIGHLIGHT_DARK_COLOR = exports.SpellCheckTypes = exports.THEME_COLORS = exports.THEME_BACKGROUND_COLORS = exports.TEXT_FORMATS = exports.TOOLBAR_CLASSNAME = exports.EXTERNAL_IMG_ATTR = exports.INLINE_IMG_ATTR = exports.PHOTO_LOADING_SRC = exports.SIZES = exports.FONT_SIZES = void 0;
var FONT_SIZES = [{
  label: 'Small',
  value: '10px'
}, {
  label: 'Normal',
  value: '13px'
}, {
  label: 'Large',
  value: '18px'
}, {
  label: 'Huge',
  value: '32px'
}];
exports.FONT_SIZES = FONT_SIZES;
var SIZES = FONT_SIZES.map(function (option) {
  return option.value;
});
exports.SIZES = SIZES;
var PHOTO_LOADING_SRC = 'https://assets.edison.tech/onmail/photo-loading.png';
exports.PHOTO_LOADING_SRC = PHOTO_LOADING_SRC;
var INLINE_IMG_ATTR = 'data-cid';
exports.INLINE_IMG_ATTR = INLINE_IMG_ATTR;
var EXTERNAL_IMG_ATTR = 'data-src';
exports.EXTERNAL_IMG_ATTR = EXTERNAL_IMG_ATTR;
var TOOLBAR_CLASSNAME = 'tinymce-toolbar';
exports.TOOLBAR_CLASSNAME = TOOLBAR_CLASSNAME;
var TEXT_FORMATS = ['fontStyle', 'fontVariant', 'fontWeight', 'fontStretch', 'fontSize', 'fontSizeAdjust', 'fontFamily', 'textAlign', 'textTransform', 'letterSpacing', 'wordSpacing', 'tabSize'];
exports.TEXT_FORMATS = TEXT_FORMATS;
var THEME_BACKGROUND_COLORS = {
  light: '#fffffe',
  dark: '#121212'
};
exports.THEME_BACKGROUND_COLORS = THEME_BACKGROUND_COLORS;
var THEME_COLORS = {
  dark: '#f2f2f2',
  light: '#000001'
};
exports.THEME_COLORS = THEME_COLORS;
var SpellCheckTypes = {
  GRAMMAR: 2,
  SPELL: 1
};
exports.SpellCheckTypes = SpellCheckTypes;
var HIGHLIGHT_DARK_COLOR = '#fd6478';
exports.HIGHLIGHT_DARK_COLOR = HIGHLIGHT_DARK_COLOR;
var HIGHLIGHT_LIGHT_COLOR = '#ffd41a';
exports.HIGHLIGHT_LIGHT_COLOR = HIGHLIGHT_LIGHT_COLOR;
var INLINE_IAMGE_MIME_TYPES = ['image/gif', 'image/jpeg', 'image/png', 'image/webp', 'image/bmp'];
exports.INLINE_IAMGE_MIME_TYPES = INLINE_IAMGE_MIME_TYPES;
//# sourceMappingURL=constants.js.map